<template>
	<div>
		<offer-form :schema="schema" class="mt6" :isBoxed="false" />
	</div>
</template>

<script>
import OfferForm from "../OfferForm.vue"
import AegPricing from "../AegPricing.vue"
import AegBinderCommission from "../AegBinderCommission.vue"

export default {
	name: "TOOffers",
	components: {
		OfferForm,
		// eslint-disable-next-line vue/no-unused-components
		AegBinderCommission
	},
	data() {
		return {
			schema: [
				{
					label: "Select Product",
					component: "selectProduct",
					bindTo: "offer.product",
					props: {
						insuranceType: "jewellers_tour"
					}
				},
				{
					label: "Policy Effective Start Date",
					component: "date",
					dataType: "date",
					bindTo: "offer.startDate"
				},
				{
					label: "Policy Effective End Date",
					component: "date",
					dataType: "date",
					bindTo: "offer.endDate"
				},
				{
					label: "Clauses",
					component: "clauses",
					bindTo: "offer"
				},
				// TODO:
				// Inject special pricing component
				// This might be a challeng for CMS
				// Perhaps we would inlcude <remote-component> in the schema that fetches this pricing component?
				{
					componentObject: AegPricing,
					label: "Pricing Calculation",
					bindTo: "offer"
				},
				{
					label: "Total Sum Insured",
					component: "number",
					dataType: "number",
					bindTo: "offer.facts.totalSumInsured"
				},
				{
					label: "Premium",
					component: "offerPremiumInfo",
					bindTo: "offer"
				},
				{
					label: "Binder",
					componentObject: AegBinderCommission,
					bindTo: "offer"
				},
				{
					label: "Customer Type",
					component: "select",
					bindTo: "offer.facts.customerType",
					props: {
						options: [
							{
								name: "Existing",
								value: "Existing"
							},
							{
								name: "New",
								value: "New"
							},
							{
								name: "Old",
								value: "Old"
							}
						]
					}
				},
				{
					label: "Quotation Accepted Date",
					component: "date",
					dataType: "date",
					bindTo: "offer.facts.acceptanceDate"
				},
				{
					label: "Filing Date",
					component: "date",
					dataType: "date",
					bindTo: "offer.facts.filingDate"
				},
				{
					label: "File Number",
					component: "text",
					bindTo: "offer.facts.fileNumber"
				},
				{
					label: "Quotation Confirm Date",
					component: "date",
					dataType: "date",
					bindTo: "offer.facts.confirmDate"
				},
				{
					label: "Quotation Customer Signed Date",
					component: "date",
					dataType: "date",
					bindTo: "offer.facts.signedDate"
				},
				{
					label: "Quotation Cancel Date",
					component: "date",
					dataType: "date",
					bindTo: "offer.facts.cancelDate"
				},
				{
					label: "Quotation Cancel Reason Code",
					component: "select",
					bindTo: "offer.facts.cancelReasonCode",
					props: {
						options: [
							{
								name: "Nonpayment",
								value: "Nonpayment"
							},
							{
								name: "Nonrenewal",
								value: "Nonrenewal"
							},
							{
								name: "Irreconcilable Differences",
								value: "Irreconcilable Differences"
							}
						]
					}
				},
				{
					label: "Quotation Cancel Description",
					component: "longText",
					bindTo: "offer.facts.cancelDescription"
				},
				{
					label: "Quotation Remarks",
					component: "longText",
					bindTo: "offer.facts.remarks"
				},
				{
					label: "Quotation Status",
					component: "select",
					bindTo: "offer.status",
					props: {
						options: [
							{
								name: "In Progress",
								value: "In Progress"
							},
							{
								name: "Purge",
								value: "Purge"
							},
							{
								name: "Rejected",
								value: "Rejected"
							},
							{
								name: "Cancel",
								value: "Cancel"
							},
							{
								name: "Updated",
								value: "Updated"
							},
							{
								name: "Closed",
								value: "Closed"
							},
							{
								name: "Withdraw",
								value: "Withdraw"
							},
							{
								name: "Settled",
								value: "Settled"
							}
						]
					}
				},
				{
					label: "Co-Insurance",
					component: "select",
					bindTo: "offer.facts.coInsurance",
					props: {
						options: [
							{
								name: "Lead",
								value: "L"
							},
							{
								name: "Follower",
								value: "F"
							},
							{
								name: "Not Coinsurance",
								value: "N"
							}
						]
					}
				},
				{
					label: "Proposal Stakeholders",
					component: "proposalStakeholders",
					bindTo: "",
					props: {
						types: [
							{ name: "Company", value: "company" },
							{ name: "Business Unit", value: "businessUnit" },
							{ name: "Policyholder", value: "policyHolder" },
							{ name: "Insured", value: "insured" },
							{ name: "Mother Company", value: "motherCompany" },
							{ name: "Contact Name", value: "contactName" },
							{ name: "Underwriter", value: "underwriter" },
							{ name: "London Broker", value: "londonBroker" },
							{ name: "Broker", value: "broker" },
							{ name: "Handled By", value: "handledBy" },
							{ name: "Signed By", value: "signedBy" },
							{ name: "Agency", value: "agency" },
							{
								name: "Third Party Referral - Company",
								value: "thirdPartyReferralCompany"
							},
							{
								name: "Third Party Referral - Individual",
								value: "thirdPartyReferralIndividual"
							},
							{ name: "Salesman", value: "salesman" },
							{ name: "Local Sub-Producer", value: "localSubProducer" },
							{ name: "Coverholder", value: "coverholder" },
							{ name: "Loss Adjuster", value: "lossAdjuster" },
							{ name: "Solicitor", value: "solicitor" },
							{ name: "Recovery From Party", value: "recoveryFromParty" }
						]
					}
				},
				{
					label: "Offer Stakeholders",
					component: "offerStakeholders",
					bindTo: "",
					props: {
						types: [
							{ name: "Company", value: "company" },
							{ name: "Business Unit", value: "businessUnit" },
							{ name: "Policyholder", value: "policyHolder" },
							{ name: "Insured", value: "insured" },
							{ name: "Mother Company", value: "motherCompany" },
							{ name: "Contact Name", value: "contactName" },
							{ name: "Underwriter", value: "underwriter" },
							{ name: "London Broker", value: "londonBroker" },
							{ name: "Broker", value: "broker" },
							{ name: "Handled By", value: "handledBy" },
							{ name: "Signed By", value: "signedBy" },
							{ name: "Agency", value: "agency" },
							{
								name: "Third Party Referral - Company",
								value: "thirdPartyReferralCompany"
							},
							{
								name: "Third Party Referral - Individual",
								value: "thirdPartyReferralIndividual"
							},
							{ name: "Salesman", value: "salesman" },
							{ name: "Local Sub-Producer", value: "localSubProducer" },
							{ name: "Coverholder", value: "coverholder" },
							{ name: "Loss Adjuster", value: "lossAdjuster" },
							{ name: "Solicitor", value: "solicitor" },
							{ name: "Recovery From Party", value: "recoveryFromParty" }
						]
					}
				}
			]
		}
	}
}
</script>
